import moment from 'moment'

if (moment.tz) {
  moment.tz.setDefault(moment.tz.guess())
}

moment.updateLocale('en', {
  relativeTime: {
    past: '%s',
    s: 'just now',
    ss: 'just now',
    m: 'a minute ago',
    mm: '%d minutes ago',
    h: 'an hour ago',
    hh: (number, withoutSuffix, key, isFuture) => {
      return number > 15 ? 'yesterday' : `${number} hours ago`
    },
    d: 'yesterday',
    dd: '%d days ago',
    M: 'a month ago',
    MM: '%d months ago',
    y: 'a year ago',
    yy: '%d years ago',
  },
})
